<template>
    <div class="card">
            <div class="thumb-nail">
                <img :src="require('@/assets/'+this.img)">
                <span class="title">{{this.title}}</span>
            </div>
            <div class="content">
                <span class="subtitle">{{this.subTitle}}</span>
                <br><br>
                <div class="float-wrap" style="text-align: center">
                    <div class="right">
                        <div class="description">
                            {{this.description}}
                        </div>
                    </div>
                    <div class="left technology">
                    
                        {{this.programmingLanguage}}
                        <ul>
                        <li v-for="(technology, index) in technologies" v-bind:key="index">{{technology}}</li>
                        </ul>
                    </div>
                    
                </div>
                <div class="button-wrap">
                    <div v-for="(button, index) in buttons" v-bind:key="index" style="display:inline-block">
                        <!--For button with url outside site-->
                        <button v-if="index==0 && button.isLocalPage==false" class="button button-primary" :onclick="'window.location.href=`'+button.link+'`'">
                            {{button.text}}</button>
                            <!--Secondary color-->
                        <button v-if="index>=1 && button.isLocalPage==false" class="button button-secondary" :onclick="'window.location.href=`'+button.link+'`'">
                            {{button.text}}</button>
                         
                        <!--For single page link-->
                        <template v-if="index==0 && button.isLocalPage!=false">
                            <router-link  :to="button.link">
                                <button class="button button-primary">{{button.text}}</button>
                            </router-link>
                        </template>
                            <!--Secondary color-->
                        <template v-if="index>=1 && button.isLocalPage!=false">
                            <router-link  :to="button.link">
                                <button class="button button-secondary">{{button.text}}</button>
                            </router-link>
                        </template>
    
                    </div>
                    <span class="date">{{this.month}}, {{this.year}}</span>
                </div>     
            </div>
            </div>
</template>

<script>
export default {
   name: 'ProjectCard',
   props:{
       img:{
           default: "logo.png",
           type: String
       },
       title:{
        default: "Title",
        type: String
    },
    subTitle:{
        default: "Subtitle",
        type: String
    },
    description:{
        default: "description",
        type: String
    },
    programmingLanguage:{
        default: "programming language",
        type: String
    },
    technologies:{
        default: function () { return ["tech1", "tech2"] },
        type: Array
    },
    buttons:{
        default: function() {return [{"text":"button", "link":"http://example.com/"},{ "text":"button2", "link":"http://example.com/"}]},
        type: Array
    },
    month:{
        default: "May",
        type: String
    },
    year:{
        default: "2020",
        type: String
    }
   },


    
}
</script>

<style scoped>

    .card {
        background-color:  #292934	;
        border-radius: .5rem;
        width: 100%;
        max-width: 90vw;
        height:auto ;
        margin: auto;
        padding: 0px;
    }
    .thumb-nail{
            border-top-left-radius: .5rem;
    border-top-right-radius: .5rem;
        width: 100%;
        overflow: hidden;
        position: relative; 
    }
    .thumb-nail>img{
    min-width: 100%;
    min-height: 40%;
    max-height: 14rem;
    height: auto;
    object-fit: cover;
    display: block;

    }
    .thumb-nail .title{
        position: absolute;
        bottom: 0px;
        left: 0px;
        width:100%;
        opacity: 0.86;
        background-color: #BADBC7		; 
        padding-left: 1rem;
        font-size: 1.5rem;
        color: #223546		; 
    }
    .content{
        padding: 1rem;
        color: #767676;
    }
            
    .float-wrap{
        display: inline-block;
        width: 100%;
    }
    .float-wrap>.left{
        float: left;
    }
    .float-wrap>.right{
        float: right;
        width: 70%;
    }
    ul{
        list-style-type: none;
        margin: 0;
        margin-left: 1rem;
        padding: 0;
    }
    .subtitle{
        color:#F0F0F0;
    }
    .technology{
        width: 29%;
        border-right: 1px solid gray;
        text-align: left;
    }
        
    .description {
        padding: 1rem; 
        word-wrap: break-word;
        text-align:left; 
        padding-top: 0rem;
    }
    
    .date{
        position: absolute;
        right: 0px;
        bottom: 0px;
        font-size: 0.80rem;
        font-weight: 100;
    }
    
    .button-wrap{
        text-align: center;
        position: relative; 
        display: inline-block;
        width: 100%;
    }

    .button{
        cursor: pointer;
        border-style: solid;
        border-width: 2px 2px 2px 2px;
        border-color: var(--button-color);
        color: var(--button-color);
        text-align: center;
        padding: 0.5rem;
        background-color: rgba(0,0,0,0);
        margin-right: 0.3em;
        }
            
    .button:hover{
        box-shadow: inset 0 -3.25em 0 0 var(--button-color);
        color: white;
        transition: 0.25s;
    }
    
    .button-primary{
        --button-color:#6AA89D;
    }
    .button-secondary{
        --button-color: #89ACD7;
    }
    .button-tertiary{
        --button-color: #e477f4;
    }

    @media screen and (max-width: 600px) {
    .technology {
        display: none;
        width: 0px;
    }
    .date{
        display: none;
    }
    .description{
        word-break: break-word;
        text-align: center;
    }
    .float-wrap>.right{
    width: 100%;
    }
}
</style>